import { Types } from '../actions/connectionActions';

export const defaultConnectionsState = {
  list: [],
  catalog: [],
  descriptor: null,
  externalAccounts: null,
  dimensionManifest: null,
  dimensionValuesByKey: {},
  mappingConfig: null,
  mappingConfigDraft: null,
  connectionInstanceId: null,
  importSummary: { needingReview: 0, jobIds: [], incompleteJobs: [], incomplete: 0 },
  loading: {},
  error: null,
};

/**
 * Update only the connections slice — do not cloneDeep the whole app state
 * (that breaks referential equality and caused infinite dimension-values fetches).
 */
const connectionReducers = (state = {}, action) => {
  if (!action?.type?.startsWith('CONN_')) return state;

  const prev = state.connections || defaultConnectionsState;

  switch (action.type) {
    case Types.CONN_SET_LIST:
      return { ...state, connections: { ...prev, list: action.payload || [] } };

    case Types.CONN_SET_CATALOG:
      return { ...state, connections: { ...prev, catalog: action.payload || [] } };

    case Types.CONN_SET_DESCRIPTOR:
      return { ...state, connections: { ...prev, descriptor: action.payload } };

    case Types.CONN_SET_EXTERNAL_ACCOUNTS:
      return { ...state, connections: { ...prev, externalAccounts: action.payload } };

    case Types.CONN_SET_DIMENSION_MANIFEST:
      return { ...state, connections: { ...prev, dimensionManifest: action.payload } };

    case Types.CONN_SET_DIMENSION_VALUES: {
      const { key, values } = action.payload || {};
      return {
        ...state,
        connections: {
          ...prev,
          dimensionValuesByKey: {
            ...prev.dimensionValuesByKey,
            [key]: values,
          },
        },
      };
    }

    case Types.CONN_SET_MAPPING_CONFIG:
      return {
        ...state,
        connections: {
          ...prev,
          mappingConfig: action.payload?.mappingConfig ?? action.payload,
          mappingConfigDraft: action.payload?.mappingConfigDraft ?? null,
          connectionInstanceId: action.payload?.connectionInstanceId ?? prev.connectionInstanceId,
        },
      };

    case Types.CONN_SET_IMPORT_SUMMARY:
      return {
        ...state,
        connections: {
          ...prev,
          importSummary: action.payload || { needingReview: 0, jobIds: [], incompleteJobs: [], incomplete: 0 },
        },
      };

    case Types.CONN_SET_LOADING: {
      const { section, value } = action.payload || {};
      return {
        ...state,
        connections: {
          ...prev,
          loading: { ...prev.loading, [section]: value },
        },
      };
    }

    case Types.CONN_SET_ERROR:
      return { ...state, connections: { ...prev, error: action.payload } };

    case Types.CONN_CLEAR_DESCRIPTOR:
      return {
        ...state,
        connections: {
          ...prev,
          descriptor: null,
          externalAccounts: null,
          dimensionManifest: null,
          dimensionValuesByKey: {},
          mappingConfig: null,
          mappingConfigDraft: null,
        },
      };

    default:
      return state;
  }
};

export default connectionReducers;
